import { GridStack } from 'gridstack';
import { HomeLayoutService as HomeLayoutServiceType } from '~/pages/home/home-layout.service';
import { BaseController } from '~/utils/base-controller';

/* globals Knitiv */

export default class extends BaseController {
	/** @type {HomeLayoutServiceType} */
	HomeLayoutService;

	/** @type {Knitiv.Scope} */
	$scope;

	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {HomeLayoutServiceType} HomeLayoutService
	 * @param {Knitiv.Scope} $scope
	 */
	constructor($injector, HomeLayoutService, $scope) {
		super($injector);

		this.$scope = $scope;
		this.HomeLayoutService = HomeLayoutService;
	}

	$onInit() {
		this.$scope.$watch(() => this.HomeLayoutService.availableWidgets, () => {
			this.$timeout(() => {
				GridStack.setupDragIn('.grid-stack-item.widget', {
					// appendTo: 'body',
					// containment: null,
					helper: () => document.createElement('div'),
				});
			});
		}, true);
	}
}
